module.exports = __webpack_public_path__ + "static/img/business_banner_decoration.3375727.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business_banner_decoration.png
// module id = X9Nr
// module chunks = 1